import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {Category, Occ, OccEndpointsService} from "@spartacus/core";
import CategoryHierarchy = Occ.CategoryHierarchy;
import {Grade, ProductQuickStockData, QuickStockData, QuickStockDataTubes} from "../interfaces/GonvarriQuickStock";
import {Channel} from "../interfaces/channel";

@Injectable({
  providedIn: 'root',
})
export class QuickStockAdapterImpl {

  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService
  ) {}

  addStockNotification(
    productCode: string,
    channels: Channel[]
  ): Observable<any> {
    const formData = new FormData();
    for (let i = 0; i < channels.length; i++) {
      formData.append("channels["+i+"].channel", channels[i].channel);
      formData.append("channels["+i+"].enabled", channels[i].enabled+"");
      formData.append("channels["+i+"].visible", channels[i].visible+"");
    }
    return this.http.post<any>(this.addStockNotificationUrl(productCode), formData);
  }

  getStockNotification(
    productCode: string
  ): Observable<any> {
    return this.http.get<any>(this.getStockNotificationUrl(productCode), {});
  }

  removeStockNotification(
    productCode: string
  ): Observable<any> {
    return this.http.post<any>(this.removeStockNotificationUrl(productCode), {});
  }

  getQuickStockCategory(categoryCode: string | undefined): Observable<QuickStockData>{
    return this.http.get<QuickStockData>(this.getQuickStockCategoryUrl(categoryCode as string), {});
  }

  getQuickStockProduct(categoryCode: string | undefined, subCategoryCode: string | undefined): Observable<Grade>{
    return this.http.get<Grade>(this.getQuickStockProductUrl(categoryCode as string, subCategoryCode as string), {});
  }

  getQuickStockTabs(): Observable<CategoryHierarchy> {
    return this.http
      .get<CategoryHierarchy>(
        this.getQuickStockTabsUrl(),
        {}
      );
  }

  getQuickStockAsturias(code: string | undefined, group: string | undefined): Observable<QuickStockDataTubes> {
    return this.http
      .get<QuickStockDataTubes>(
        this.getQuickStockAsturiasUrl(code as string, group as string),
        {}
      );
  }

  getQuickStockTabsUrl(): string {
    const queryParams = {
      fields: 'FULL'
    }
    return this.occEndpointsService.buildUrl(`/quickStock/categories/`, {
      queryParams
    })
  }

  getQuickStockProductUrl(categoryCode: string, subCategoryCode: string): string {
    const queryParams = {
      fields: 'FULL'
    };
    return this.occEndpointsService.buildUrl(`/quickStock/view/${categoryCode}/subcategory/${subCategoryCode}`, {
      queryParams
    })
  }

  getQuickStockCategoryUrl(categoryCode: string): string {
    const queryParams = {
      fields: 'FULL'
    }
    return this.occEndpointsService.buildUrl(`/quickStock/view/${categoryCode}`, {
      queryParams
    })
  }

  addStockNotificationUrl(
    productCode: string
  ): string {
    const queryParams = {
      fields: 'FULL'
    }
    return this.occEndpointsService.buildUrl(`/my-account/my-stocknotification/add/${productCode}`, {
      queryParams
    })
  }

  getStockNotificationUrl(productCode: string): string {
    const queryParams = {
      fields: 'FULL'
    }
    return this.occEndpointsService.buildUrl(`/my-account/my-stocknotification/open/${productCode}`, {
      queryParams
    })
  }

  removeStockNotificationUrl(productCode: string): string {
    const queryParams = {
      fields: 'FULL'
    }
    return this.occEndpointsService.buildUrl(`/my-account/my-stocknotification/remove/${productCode}`, {
      queryParams
    })
  }

  getQuickStockAsturiasUrl(code: string, group: string): string {
    const queryParams = {
      fields: 'FULL'
    }
    return this.occEndpointsService.buildUrl(`/quickStock/tubes/${code}/${group}`, {
      queryParams
    })
  }

}
